import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "navigation-qlist" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList.filter(i => (i.subnodes ?? []).length === 0), (item) => {
      return (_openBlock(), _createBlock(_component_q_item, {
        key: item.id,
        class: _normalizeClass({ active: item.isActive }),
        clickable: "",
        onClick: ($event: any) => (_ctx.handleStandaloneClick(item)),
        role: "menuitem",
        "aria-label": item.node,
        "aria-current": item.isActive ? 'page' : undefined
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { avatar: "" }, {
            default: _withCtx(() => [
              (item.iconClass && item.iconClass.length > 0)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: item.iconClass,
                    size: "lg",
                    class: "width-24"
                  }, null, 8, ["icon"]))
                : (item.iconImage && item.iconImage.length > 0)
                  ? (_openBlock(), _createBlock(_component_q_img, {
                      key: 1,
                      src: _ctx.getIconSource(item.iconImage),
                      "error-src": _ctx.getIconSource('dashboard-icon.svg'),
                      class: "icon-image",
                      loading: "lazy"
                    }, null, 8, ["src", "error-src"]))
                  : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: item.path,
                class: _normalizeClass(item.isActive ? 'text-body-bold' : 'text-body-semi-bold')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.node), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["class", "onClick", "aria-label", "aria-current"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList.filter(i => (i.subnodes ?? []).length > 0), (item) => {
      return (_openBlock(), _createBlock(_component_q_expansion_item, {
        key: item.id,
        label: item.node,
        modelValue: item.isActive,
        "onUpdate:modelValue": ($event: any) => ((item.isActive) = $event),
        "expand-icon": "keyboard_arrow_down",
        "collapse-icon": "keyboard_arrow_up",
        group: "navigation-group",
        class: _normalizeClass([item.isActive ? 'active' : '']),
        onClick: ($event: any) => (_ctx.handleHeaderClick(item)),
        role: "menuitem",
        "aria-label": item.node,
        "aria-expanded": item.isActive,
        "aria-current": item.isActive ? 'page' : undefined
      }, {
        header: _withCtx(() => [
          _createVNode(_component_q_item_section, { avatar: "" }, {
            default: _withCtx(() => [
              (item.iconClass && item.iconClass.length > 0)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: item.iconClass,
                    size: "lg",
                    class: "width-24"
                  }, null, 8, ["icon"]))
                : (item.iconImage && item.iconImage.length > 0)
                  ? (_openBlock(), _createBlock(_component_q_img, {
                      key: 1,
                      src: _ctx.getIconSource(item.iconImage),
                      "error-src": _ctx.getIconSource('dashboard-icon.svg'),
                      class: "icon-image",
                      loading: "lazy"
                    }, null, 8, ["src", "error-src"]))
                  : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024),
          _createElementVNode("span", {
            class: _normalizeClass(item.isActive ? 'text-body-bold' : 'text-body-semi-bold'),
            onClick: ($event: any) => (_ctx.handleHeaderClick(item))
          }, _toDisplayString(item.node), 11, _hoisted_2)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subnodes, (subItem) => {
            return (_openBlock(), _createBlock(_component_q_card, {
              key: subItem.id,
              class: _normalizeClass({ active: _ctx.firstTwoSegmentsMatch(_ctx.route.path, subItem.path) })
            }, {
              default: _withCtx(() => [
                (_ctx.isSubnodeVisible(subItem))
                  ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                      default: _withCtx(() => [
                        (_ctx.isExternalRouteSubnode(subItem, item.node))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "#",
                              onClick: ($event: any) => (_ctx.handleSubnodeClick(subItem, item.node, $event))
                            }, _toDisplayString(subItem.node), 9, _hoisted_3))
                          : (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              to: subItem.path,
                              class: _normalizeClass(_ctx.firstTwoSegmentsMatch(_ctx.route.path, subItem.path) ? 'text-body-bold' : 'text-body-semi-bold'),
                              role: "menuitem",
                              "aria-label": subItem.node,
                              "aria-current": _ctx.firstTwoSegmentsMatch(_ctx.route.path, subItem.path) ? 'page' : undefined
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(subItem.node), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "class", "aria-label", "aria-current"]))
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["class"]))
          }), 128))
        ]),
        _: 2
      }, 1032, ["label", "modelValue", "onUpdate:modelValue", "class", "onClick", "aria-label", "aria-expanded", "aria-current"]))
    }), 128))
  ]))
}